import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

import KeyValueRow from 'components/purchase-order/KeyValueRow';

import { useUserContext } from 'providers/UserProvider';
import { getGrnSourceInfo } from 'constants/grn/grnType';
import { TIME_OPTION } from 'constants/time';

const GrnViewMode = ({ grn }) => {
  const { selectedTenant, selectedWarehouse } = useUserContext();

  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const { isGatePassGrn, sourceCode, sourceDetailPath } = getGrnSourceInfo(
    grn,
    tenant,
    warehouse,
  );

  return (
    <>
      <h5 className="mb-3 fs-9">General Details</h5>

      <Row>
        <Col md={4}>
          <KeyValueRow
            label={isGatePassGrn ? 'Gate Pass Code' : 'PO Code'}
            value={
              sourceCode ? (
                <Link to={sourceDetailPath}>
                  <strong>{sourceCode}</strong>
                </Link>
              ) : null
            }
          />

          <KeyValueRow
            label="Invoice Code"
            value={grn?.purchase_order?.invoice_code}
          />

          <KeyValueRow
            label="Vendor Name"
            value={grn?.purchase_order?.vendor?.name}
          />

          <KeyValueRow
            label="Invoice Date"
            value={
              grn?.purchase_order?.invoice_date
                ? new Date(grn?.purchase_order?.invoice_date).toLocaleString(
                    'en-IN',
                    TIME_OPTION,
                  )
                : null
            }
          />
        </Col>

        <Col md={4}>
          <KeyValueRow label="Received Amount" value={grn?.received_amount} />

          <KeyValueRow
            label="Received Quantity"
            value={grn?.received_quantity}
          />
        </Col>

        <Col md={4}>
          <KeyValueRow label="Created By" value={grn?.created_by?.email} />

          <KeyValueRow
            label="Created"
            value={new Date(grn?.created).toLocaleString('en-IN', TIME_OPTION)}
          />

          <KeyValueRow
            label="Updated"
            value={new Date(grn?.modified).toLocaleString('en-IN', TIME_OPTION)}
          />
        </Col>
      </Row>
    </>
  );
};

export default GrnViewMode;
